import { viperApi, clinicalApiPath } from '@/services/viper-api'

export const roleService = {
  basePath: `${clinicalApiPath}/roles`,

  list() {
    return viperApi.get(this.basePath)
  }
}
